// Not404Page.tsx
import React from "react";

import Sorries from "../../components/sorries";
import DefaultBasePage from "./base"; // ajuste o caminho conforme necessário

const Not404Page: React.FC = () => {
  return (
    <DefaultBasePage title="Página não encontrada!">
      <Sorries />
    </DefaultBasePage>
  );
};

export default Not404Page;
